// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";

export default class ListBoatPricesRequest {

    public areaId: string | null = null;

    public readonly isListBoatPricesRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ListBoatPricesRequest) || ((from as any).isListBoatPricesRequest === true));
    }

    public static as(from?: object | null): ListBoatPricesRequest | null {
        return (ListBoatPricesRequest.is(from)) ? from as ListBoatPricesRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(ListBoatPricesRequest, "ListBoatPricesRequest");